import React, { useEffect, useState } from 'react'
import Selector from '../../Components/Select/Select'
import {  getReportTypeTeacher } from '../../Service/report'
import { report } from '../../store/report'
import { reportTeacher } from '../../store/reportTeacher'
import { observer } from 'mobx-react-lite'
// import { SelectType } from '../../store/models'
import http from '../../Service/http'
import { direction } from '../../store/direction'
import { SelectTypeTeacher } from '../../store/modelsTeacher'

function ApplicationsExpect() {
	const [reportType, setReportType] = useState<SelectTypeTeacher>({
		label: 'Все',
		value: 0
	})

	const getReport = async () => {
		const res = await getReportTypeTeacher()
		report.newReportTypes(res)
	}
	useEffect(() => {
		getReport()
	}, [])


	const getReportsTeacher = async (id?: number) => {
		const a = await http.post(`/report/reportApplicationTeacher?reportType=${id}`)
		reportTeacher.newReportTeacher(a.data.reportApplicationTeacherWait)
	}
	
	
	useEffect(() => {
		if(reportType?.value!==0 && direction.leftOrRight == 'left' ){
		getReportsTeacher(reportType.value)
		reportTeacher.newTypeTeacher(reportType.value)}
		else if(direction.leftOrRight == 'left' ){
			getReportsTeacher()
		}
	}, [direction.leftOrRight,reportType])

	return (
		<>
			<div style={{ margin: '0 auto', width: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
				<Selector
					options={[
						{
							value: 0,
							label: 'Все'
						},
						...report.reportTypes
					]}
					value={reportType}
					placeholder={'Выберите!'}
					onChange={setReportType}
					isSearchable={true}
					isDisabled={false}
					isClearable={false}
					title={''}
					name={'search'}
					withBorder={true}
				/>
			</div>
		</>
	)
}

export default observer(ApplicationsExpect)
